import React from 'react';
import { useSaucerSelector } from '@saucerjs/core';
import { renderChildren, } from '../render/renderChildren';
/**
 * Common Render AST Children
 */
export function useRenderChildren(options) {
    var ast = useSaucerSelector(function (state) { return state.ast; });
    return React.createElement(React.Fragment, null, renderChildren(ast.children, '', options));
}
